//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import IconView from "@/components/objects/IconView.vue";
import { LIST_COLORS, BUILD_STORAGE_IMAGE_PATH } from "@/constants/ui.js";
import typo from "ru-typo";
import { v4 as uuidv4 } from 'uuid';
import { DesignExtra } from "@/utils/dto/objects.js";
import { adjustColorBrightness } from "@/utils/helpers.js";

export default {
  name: "MinimalismLinks",
  components: { IconView },
  inject: {
    specialProject: {
      default: false
    },
    source: {
      default: ''
    }
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      required: false,
      default: () => ''
    },
    objectLabel: {
      type: String,
      required: false,
      default: () => {}
    },
    design: {
      type: String,
    },
    design_extra: {
      type: [Object, DesignExtra],
      default: () => {}
    },
    template: {
      type: Object,
    },
    theme: {
      type: String,
    },
    listInfo: {
      type: Object
    },
    user: {
      type: Object,
      default: () => {}
    },
    useStorage: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      colors: [...LIST_COLORS],
    }
  },

  computed: {
    linkItemsOnlyCount() {
      return this.items.filter(i => !i.loader).length
    },
    coloredItems() {
      let insertIndex = 0

      const linksOnly = this.items.filter(l => !l.loader)
      const hasLoadMore = this.items.some(l => l.loader)

      const items = linksOnly.map((link, index) => {
        const item = JSON.parse(JSON.stringify(link))
        item.id = `${link.id || link.uuid || index}_${index}`
        const title = this.getLinkTitle(link)
        item.value = {
          type: 'plain',
          data: title
        }
        item.icon = link.target_object?.event_icon || link.target_object?.type?.icon || item.icon
        item.hasObjectImage = !!(link.target_object && link.target_object.has_image)
        item.objectImagePath = item.hasObjectImage
          ? (this.useStorage
            ? BUILD_STORAGE_IMAGE_PATH(link.image)
            : `/public/object_images_files/first_image/${link.target_object.id}/?preview=1`)
          : ''
        item.color = this.getBlockBorderColor(index + 1)
        item.iconBg = this.getIconBg(index)
        item.iconBorderColor = this.getIconBorderColor(index)
        item.iconColor = this.getIconColor
        item.humanReadableValue = this.buildHumanReadable(item.value)
        item.description = this.getLinkSubtitle(link)
        item.targetRoute = this.getLinkRoute(link)
        return item
      })

      // if (!this.isSmall && items.length % 2 !== 0) {
      items.splice(insertIndex, 0, {
        id: uuidv4(),
        humanReadableValue: {
          val: [this.label]
        },
        color: this.getBlockBorderColor(insertIndex),
        iconBg: this.getIconBg(insertIndex),
        iconBorderColor: this.getIconBorderColor(insertIndex),
        iconColor: this.getIconColor,
        value: {
          type: 'label'
        }
      })

      if (hasLoadMore) {
        items.push({
          id: 'load-next',
          loader: true,
        })
      }

      return items
    },
    paletteList() {
      return this.$store.state["property_templates"]["consts"].palette;
    },
    blockBorderPalette() {
      if (this.design_extra?.block_border?.palette && this.paletteList) {
        return this.paletteList.filter(el => el.id === this.design_extra.block_border.palette)[0];
      }

      return null;
    },
    iconBorderPalette() {
      if (this.design_extra?.icon_border?.palette && this.paletteList) {
        return this.paletteList.filter(el => el.id === this.design_extra.icon_border.palette)[0];
      }

      return null;
    },
    iconBgPalette() {
      if (this.design_extra?.icon_bg?.palette && this.paletteList) {
        return this.paletteList.filter(el => el.id === this.design_extra.icon_bg.palette)[0];
      }

      return null;
    },
    getTextColor() {
      return this.design_extra?.text?.color ?? '#212121' ?? null;
    },
    getFirstBlockTitleColor() {
      return this.design_extra?.first_block?.title_color ?? '#212121' ?? null;
    },
    getIconColor() {
      return this.design_extra?.icon_color?.color ?? 'black';
    },
    getIconGradientEnabled() {
      return this.design_extra?.icon_bg?.gradient_enabled ?? null;
    },
    getIconGradientDirection() {
      return this.design_extra?.icon_bg?.gradient_direction ?? null;
    },
    getIconGradientShadowDirection() {
      return this.design_extra?.icon_bg?.gradient_shadow_direction ?? null;
    },
  },
  methods: {
    minimalismRowGridStyle(item) {
      if (item.loader) return null
      const linkRows = this.coloredItems.slice(1).filter(i => !i.loader)
      const idxInLinks = linkRows.findIndex(r => r.id === item.id)
      if (idxInLinks === linkRows.length - 1 && linkRows.length % 2 === 1) {
        return 'grid-column-end: span 2;'
      }
      return null
    },
    getLinkTitle(link) {
      const o = link?.target_object
      if (!o) return (link?.text ?? '').trim() || ''
      if (link.use_full_label) {
        return o.label || o.short_label || o.slug || ''
      }
      return o.short_label || o.label || o.slug || ''
    },
    getLinkSubtitle(link) {
      const custom = (link?.text ?? '').trim()
      if (custom && link.target_object) {
        return typo(custom, { hyphens: true })
      }
      const html = link?.target_object?.text
      if (!html || typeof html !== 'string') return ''
      const snippet = this.firstSentenceFromHtml(html)
      return snippet ? typo(snippet, { hyphens: true }) : ''
    },
    getLinkRoute(link) {
      const slug = link?.target_object?.slug
      if (!slug) return null

      const route = {
        name: 'objects-slug',
        params: { slug },
      }
      if (this.source) {
        route.query = { from: this.source }
      }
      return route
    },
    stripHtmlTags(html) {
      if (!html || typeof html !== 'string') return ''
      return html
        .replace(/<\/?[^>]+(>|$)/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
    },
    firstSentenceFromHtml(html) {
      const plain = this.stripHtmlTags(html)
      if (!plain) return ''
      const m = plain.match(/^[\s\S]+?[.!?](?=\s|$)/u)
      if (m) return m[0].trim()
      return plain
    },
    getBlockBorderColor(index) {
      if (this.blockBorderPalette) {
        return [this.blockBorderPalette.main_color, ...this.blockBorderPalette.colors][index % [this.blockBorderPalette.main_color, ...this.blockBorderPalette.colors].length];
      } else if (this.design_extra?.block_border?.color) {
        return this.design_extra.block_border.color
      }

      return null;
    },
    getIconBorderColor(index) {
      if (this.iconBorderPalette) {
        return [this.iconBorderPalette.main_color, ...this.iconBorderPalette.colors][index % [this.iconBorderPalette.main_color, ...this.iconBorderPalette.colors].length];
      } else if (this.design_extra?.icon_border?.color) {
        return this.design_extra.icon_border.color
      }

      return null;
    },
    getIconBg(index) {
      if (this.getIconGradientEnabled) {
        if (this.iconBgPalette) {
          const color = [this.iconBgPalette.main_color, ...this.iconBgPalette.colors][index % [this.iconBgPalette.main_color, ...this.iconBgPalette.colors].length];
          return `linear-gradient(to ${this.getIconGradientDirection}, ${this.getIconGradientShadowDirection === 'transparent' ? `${color}, transparent` : `${color}, ${adjustColorBrightness(color, 1.20)}`})`
        } else if (this.design_extra?.icon_bg?.color) {
          const color = this.design_extra.icon_bg.color;
          return `linear-gradient(to ${this.getIconGradientDirection}, ${this.getIconGradientShadowDirection === 'transparent' ? `${color}, transparent` : `${color}, ${adjustColorBrightness(color, 1.20)}`})`
        }
      } else {
        if (this.iconBgPalette) {
          return [this.iconBgPalette.main_color, ...this.iconBgPalette.colors][index % [this.iconBgPalette.main_color, ...this.iconBgPalette.colors].length];
        } else if (this.design_extra?.icon_bg?.color) {
          return this.design_extra.icon_bg.color
        }
      }

      return null;
    },
    buildHumanReadable(value) {
      if (!value || value.type !== 'plain') {
        return { val: [''] }
      }
      return { val: [value.data] }
    },
  }
}
